import { CEStepAttributesBase } from './ce-step-attributes-base'


export class CEStepAttributes extends CEStepAttributesBase {

}